module.exports = __webpack_public_path__ + "media/base/teammember_big-5d1560c0.svg";